import React, { useEffect, useState } from "react";
import { X, Check } from "lucide-react";

interface Props {
  header: string;
  line?: string;
  error?: boolean;
  onClose: () => void;
  duration?: number;
}

const Toaster: React.FC<Props> = ({ header, line = "", error = false, onClose, duration = 4000 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Fade in
    const showTimer = setTimeout(() => setVisible(true), 10);

    // Start fade out after duration
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, duration);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [duration]);

  // Remove from DOM only after fade-out is done
  useEffect(() => {
    if (!visible) {
      const removalTimer = setTimeout(onClose, 300); // match animation duration
      return () => clearTimeout(removalTimer);
    }
  }, [visible, onClose]);

  return (
    <div
      className={`w-[400px] max-lg:w-[300px] p-4 rounded-lg bg-white shadow-md flex gap-2 transition-all duration-300 ease-in-out transform
        ${visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-20"}
        ${!line ? "items-center" : "items-start"}
      `}
    >
      <div className={`w-5 h-5 rounded-full flex items-center justify-center ${error ? "bg-red-500" : "bg-green-500"}`}>
        {error ? <X className="text-white w-4 h-4" /> : <Check className="text-white w-4 h-4" />}
      </div>
      <div className="flex flex-col gap-1">
        <h1 className="font-semibold text-st text-textblack">{header}</h1>
        {line && <p className="text-ft text-textlightgrey">{line}</p>}
      </div>
      <button className="ml-auto" onClick={() => setVisible(false)}>
        <X className="text-gray-400 h-5 w-5" />
      </button>
    </div>
  );
};

export default Toaster;
